import SearchModal from './SearchModal.js';

export default SearchModal;